import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularPortfolio: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_portfolio"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="portfolio icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.4229 2C13.4564 2 12.6729 2.7835 12.6729 3.75V9.57692C12.6729 10.5434 13.4564 11.3269 14.4229 11.3269H20.2498C21.2163 11.3269 21.9998 10.5434 21.9998 9.57692V4.25C21.9998 3.00736 20.9924 2 19.7498 2H14.4229ZM14.1729 3.75C14.1729 3.61193 14.2848 3.5 14.4229 3.5H19.7498C20.164 3.5 20.4998 3.83579 20.4998 4.25V9.57692C20.4998 9.71499 20.3878 9.82692 20.2498 9.82692H14.4229C14.2848 9.82692 14.1729 9.71499 14.1729 9.57692V3.75Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.25 4.84619C3.00736 4.84619 2 5.85355 2 7.09619V19.7498C2 20.9924 3.00736 21.9998 4.25 21.9998H16.9041C18.1467 21.9998 19.1541 20.9924 19.1541 19.7498V14.4229C19.1541 13.4564 18.3706 12.6729 17.4041 12.6729H11.3269V6.59619C11.3269 5.62969 10.5434 4.84619 9.57692 4.84619H4.25ZM9.82692 12.6729V6.59619C9.82692 6.45812 9.71499 6.34619 9.57692 6.34619H4.25C3.83579 6.34619 3.5 6.68198 3.5 7.09619V12.6729H9.82692ZM3.5 14.1731H9.82692V20.4998H4.25C3.83579 20.4998 3.5 20.164 3.5 19.7498V14.1731ZM11.3271 14.1729V20.4998H16.9041C17.3183 20.4998 17.6541 20.164 17.6541 19.7498V14.4229C17.6541 14.2848 17.5421 14.1729 17.4041 14.1729H11.3271Z"
        />
      </svg>
    </span>
  );
};

export { RegularPortfolio };
